import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, FlatList, Pressable, TouchableOpacity, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { Ionicons, MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
import ButtonGradient from '../modules/component/ButtonGradient';
import * as Location from 'expo-location';
import theme from './../../lib/theme.js';
import { apiFetch } from '../modules/api';

function MyCheckbox(valor) {

  var estaSel = false;
  const [pIncidencia, SetPincidencia] = useState(valor.incidencia.id);
  const [pIdIncidencia, SetPIdIncidencia] = useState(valor.incidencia.id);

  if (valor.incidencia.seleccionado === "1") {

    estaSel = true;

  }

  const [checked, onChange] = useState(estaSel);


  if (valor.incidencia.seleccionado === "1") {

    actualizarValor1();

  }



  function onCheckmarkPress() {



    onChange(!checked);
    actualizarValor2();


  }

  function actualizarValor1() {

    if (checked) {

      gCheckboxSeg[pIncidencia] = 1
      gCheckboxSegId[pIdIncidencia] = pIdIncidencia


    } else {

      gCheckboxSeg[pIncidencia] = 0
      gCheckboxSegId[pIdIncidencia] = pIdIncidencia
    }

  }

  function actualizarValor2() {

    if (!checked) {

      gCheckboxSeg[pIncidencia] = 1
      gCheckboxSegId[pIdIncidencia] = pIdIncidencia

    } else {

      gCheckboxSeg[pIncidencia] = 0
      gCheckboxSegId[pIdIncidencia] = pIdIncidencia

    }

  }



  return (
    <Pressable
      style={[styles.checkboxBase, checked && styles.checkboxChecked]}
      onPress={onCheckmarkPress}>
      {checked && <Ionicons name="checkmark" size={24} color="white" />}
    </Pressable>


  );
}


const Incidencias = () => {


  const navigation = useNavigation();


  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const showAlert = () =>

    Alert.alert('La información se guardo de manera exitosa', 'Oprima Aceptar para continuar', [
      {
        text: "Aceptar",
        onPress: () => navigation.goBack()
      }
    ],
      { cancelable: true });


  async function validarGpsEncendido() {

    let { status } = await Location.requestForegroundPermissionsAsync();

    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
      showAlert();
      navigation.navigate("Acceso");
      return;
    } else {
      let location = await Location.watchPositionAsync(
        {
          accuracy: Location.Accuracy.High,
          timeInterval: 5000,
          distanceInterval: 10
        },
        (loc) => {
          gGeo = loc.coords;
        }
      );
    }
  }

  const [incidencia, setIncidencia] = useState(null);
  const [incidenciaUPC, setIncidenciaUPC] = useState([]);

  useEffect(function () {
    let mounted = true;
    (async () => {
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== 'granted') {
        setErrorMsg('Permission to access location was denied');
        navigation.navigate("Acceso");
        return;
      }

      return () => mounted = false;
    })();
    fetchData(mounted);
    
    return () => mounted = false;

  }, []);

  useEffect(function () {
    let mounted = true;
    navigation.addListener('focus', () => {
      if (mounted) {
        fetchData(mounted);
      }
    });
    return () => mounted = false;
  }, []);

  async function fetchData() {

      const datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + gUpc + '"}'

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos

      }

      const response = await apiFetch(gApiPath + "/api/listarIncidenciasSeguimiento", requestOptions);
      const json = await response.json();

      const incidenciasFiltradas = json.datos.reduce((result, current) => {
        const existentItem = result.find(item => item.upc === current.upc);
        if (!existentItem) {
          result.push(current);
        }
        return result;
      }, []);

      setIncidencia(json.datos);
      setIncidenciaUPC(incidenciasFiltradas);
      setIsLoading(false);

      gCheckboxSeg = {};

  }

  const irIncidenciaUPC = (upc) => {
    navigation.navigate("TareasPendientesUPC", {data: incidencia, upc: upc});
  }

  const Spacer = ({ height = 16 }) => <View style={{ height }} />;

  const getDeterminanteDetalle = (data, opc) => {
    const text = data.split("-");
    if (opc === 1) {
      if (text.length > 0) {
        return text[0].trim();
      }
    }
    if (opc === 2) {
      if (text.length > 1) {
        return text[1].trim();
      }
    }
    return "";
  }

  return (
    <View style={{ flex: 1, width: '100%' }}>
      <Fondo />
      <View style={{...styles.header,  height: "120px", width: "100%"}} >
        <View
          style={{
            ...theme.cards, backgroundColor: "#fff",
            flexWrap: 'wrap', flex: 1, justifyContent: "center"
          }}>
          <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
            <MaterialCommunityIcons style={{ textAlign: 'center', marginTop: -10 }} name="store" size={50} color="#333" />
          </View>
          <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
            <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>{gOperador.toUpperCase() + " - " + gDeterminante.toUpperCase()}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 1)}{}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 2)}{}</Text>
          </View>
        </View>
      </View>
      <View style={{ alignItems: 'center', flexDirection: 'row', flex: 0 }} >
      </View>
      {!isLoading && incidenciaUPC.length > 0 ?
        <FlatList
          style={{ flex: 1, aignItems: 'center', width: '100%', maxHeight: "75vh" }}
          data={incidenciaUPC}
          keyExtractor={item => item.id}
          renderItem={({ item }) =>
            <View style={{ flex: 1, aignItems: 'center', width: '100%', shadowOpacity: 0, elevation: 0 }}>
              <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.warning, flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center" }} onPress={() => irIncidenciaUPC(item.upc)}>
                <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
                  <MaterialIcons style={{ textAlign: 'center' }} name="local-grocery-store" size={50} color="#fff" />
                </View>
                <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
                  <Text style={theme.storeCardTitle} >UPC: {item.upc} </Text>
                  <Text style={theme.storeCardText} >{item.descripcion} </Text>
                </View>
              </TouchableOpacity>
            </View>}
        /> : null}
      {isLoading && (
        <Text>Cargando...</Text>
      )}
      {!isLoading && incidenciaUPC.length === 0 && 
       <View style={{ flex: 1, aignItems: 'center'}}>
         <MaterialIcons name="check-circle" style={{ textAlign: 'center' }} size={100} color={theme.colors.success} />
         <Text style={{...theme.subTitle2, textAlign: 'center'}} ellipsizeMode="tail" numberOfLines={3}>No quedan incidencias para esta tienda</Text>
      </View>}
    </View>
  );
}

export default Incidencias

const styles = StyleSheet.create({

  titulo: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  }, text: {
    fontSize: 13,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 20,
  },

  titulo2: {
    fontSize: 25,
    paddingLeft: 45,
    color: "black",
    fontWeight: 'bold',
    marginTop: 10


  },

  titulo3: {
    fontSize: 15,
    color: "white",
    fontWeight: 'bold',
    marginRight: 30,
    textAlign: 'center'
  },

  titulo4: {
    fontSize: 20,
    color: "white",
    fontWeight: 'bold',
    marginRight: 30,
    textAlign: 'center'
  },
  button: {

    padding: 15,
    width: '100%',
    height: '90%',
    borderRadius: 20,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 2,
    marginBottom: 2,
    marginRight: 12

  },
  container2: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',

  }, checkboxBase: {
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    borderWidth: 2,
    borderColor: 'coral',
    backgroundColor: 'transparent',
  }, container5: {
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    width: '80%'
  },

  checkboxChecked: {
    backgroundColor: 'coral',
  },

  checkboxContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20,
    width: '90%'

  },
  TableText: {
    fontSize: 13,
    margin: 10,
    textAlign: 'center',
    color: "white",
    fontWeight: 'bold'
  },
  textTable: {

    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "black",
    textAlign: 'center',
    width: "98%",
    marginTop: 20

  }


});


